import { render } from "./OverlayElementInfo.vue?vue&type=template&id=7f90356a&scoped=true"
import script from "./OverlayElementInfo.vue?vue&type=script&lang=js"
export * from "./OverlayElementInfo.vue?vue&type=script&lang=js"

import "./OverlayElementInfo.vue?vue&type=style&index=0&id=7f90356a&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f90356a"]])

export default __exports__